import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const findShipmentCheckList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v1/shipment/checkList?` + params,
        method: 'GET'
    })
}
export const findShipmentCheckList2 = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v1/shipment/checkList2?` + params,
        method: 'GET'
    })
}
export const findShipmentCheckList2DownloadExcel = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v1/shipment/checkList2Excel?` + params,
        method: 'GET'
    })
}